import { FormattedMessage } from "react-intl";
import { ModalCompact, ModalCompactBody, ModalCompactHead } from "../common";
import TaskDetailsBase from "./TaskDetails/TaskDetailsBase";
import TaskDetailsGrid from "./TaskDetails/TaskDetailsGrid";

const handleShiftKeyDown = (e) => {
  if (e.shiftKey) {
    e.stopPropagation();
    e.nativeEvent?.stopPropagation();
  }
}
const handleShiftKeyUp = (e) => (e.key === "Shift") && e.stopPropagation();

const TaskDetailsModal = ({
  columns,
  currentProject,
  disabled,
  enableEdit,
  onClose,
  onDelete,
  onSave,
  onTimeLogAction,
  open,
  task,
  userLookup,
}) => (
  <ModalCompact
    fullScreen
    handleClose={onClose}
    onKeyDown={handleShiftKeyDown}
    onKeyUp={handleShiftKeyUp}
    open={open}
  >
    <ModalCompactHead
      handleClose={onClose}
      title={
        task.id
          ? <FormattedMessage id="project.taskContextMenu.editTask" />
          : <FormattedMessage id="project.buttons.addTask" />
      }
    />
    <ModalCompactBody>
      <TaskDetailsBase
        columns={columns}
        currentProject={currentProject}
        disabled={disabled}
        enableEdit={enableEdit}
        item={task}
        onDelete={onDelete}
        onSave={onSave}
        onTimeLogAction={onTimeLogAction}
        renderComponent={TaskDetailsGrid}
        userLookup={userLookup}
      />
    </ModalCompactBody>
  </ModalCompact>
);

export default TaskDetailsModal;
